"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const Button_1 = __importDefault(require("./Button"));
exports.CircleButton = (0, styled_components_1.default)(Button_1.default).attrs({
    variant: 'circleBtn',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    width: '50px',
    height: '50px',
    boxShadow: 'large',
    backgroundColor: 'bgDarkBlue',
    mt: 3,
}));
//# sourceMappingURL=CircleButton.js.map